module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg34-e058e7f6871943f1854254e12695f1a0.jpg";